/*
 *
 * GoogleCalendarManager reducer
 *
 */
import { fromJS } from 'immutable';
import {
	FETCH_CALENDARS_REQUEST,
	FETCH_CALENDARS_SUCCESS,
	FETCH_CALENDARS_FAILURE,
	DELETE_CALENDAR_REQUEST,
	DELETE_CALENDAR_SUCCESS,
	DELETE_CALENDAR_FAILURE,
} from './constants';

export const initialState = fromJS({
	calendars: [],
	loading: false,
	error: null,
	deleting: false,
});

function googleCalendarManagerReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_CALENDARS_REQUEST:
			return state.set('loading', true).set('error', null);
		case FETCH_CALENDARS_SUCCESS:
			return state.set('loading', false).set('calendars', action.calendars);
		case FETCH_CALENDARS_FAILURE:
			return state.set('loading', false).set('error', action.error);
		case DELETE_CALENDAR_REQUEST:
			return state.set('deleting', true).set('error', null);
		case DELETE_CALENDAR_SUCCESS:
			const calendars = state.get('calendars');
			const updatedCalendars = Array.isArray(calendars)
				? calendars.filter((c) => c.id !== action.calendarId)
				: [];
			return state
				.set('deleting', false)
				.set('calendars', updatedCalendars);
		case DELETE_CALENDAR_FAILURE:
			return state.set('deleting', false).set('error', action.error);
		default:
			return state;
	}
}

export default googleCalendarManagerReducer;
